/**
 * Default landing route for a PoR workspace — first visible page per workspace settings.
 */
import { Navigate } from 'react-router-dom';
import { usePorPageVisibility } from '../../hooks/usePorPageVisibility';
import { usePlanInstrumentNav } from '../../contexts/PlanInstrumentNavContext';

export function PorDefaultRedirect({ porId }: { porId: string }) {
  const { porHref } = usePlanInstrumentNav();
  const { loading, defaultLandingSegment } = usePorPageVisibility(porId);

  if (loading) {
    return (
      <div className="border border-[var(--rule)] dark:border-[var(--rule)] bg-[var(--bg-raised)] dark:bg-[var(--bg-raised)] px-6 py-12 text-center">
        <p className="text-sm text-[var(--text-ter)] dark:text-[var(--text-sec)]">Loading…</p>
      </div>
    );
  }

  return <Navigate to={porHref(porId, defaultLandingSegment)} replace />;
}
